import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import type { PaginationRequiredQueryInterface } from '@zaoblako/shared/common/dtos/pagination-required-query.dto';
import type { TaskTemplateHistoryFindInterface } from '@zaoblako/shared/modules/task/dtos/template/task.template.history.find.dto';
import { TaskTemplateService } from '@zaoblako/web/core/services/task/task-template.service';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  standalone: true,
  selector: 'crm-task-template-history-widget',
  templateUrl: './task-template-history-widget.component.html',
  imports: [CommonModule, CardModule, SpinnerComponent, ProgressSpinnerModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskTemplateHistoryWidgetComponent implements OnInit {
  @Input() public templateId: number;

  public historyItems: TaskTemplateHistoryFindInterface[];
  public queryParamsHistory: PaginationRequiredQueryInterface = {
    limit: 100,
    offset: 0
  };

  public loadingHistory = false;
  public paginationLoadingHistory = false;
  public countItemsHistory: number;

  public constructor(
    private readonly taskTemplateService: TaskTemplateService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.loadHistory();
  }

  public loadHistory({ concat } = { concat: false }) {
    if (!concat) {
      this.loadingHistory = true;
    }

    this.taskTemplateService.historyById(this.templateId, this.queryParamsHistory).subscribe({
      next: (data) => {
        this.queryParamsHistory.limit = data.limit;
        this.queryParamsHistory.offset = data.offset;
        this.countItemsHistory = data.count;
        this.historyItems = concat ? this.historyItems.concat(data.items) : data.items;
        this.paginationLoadingHistory = false;
        this.loadingHistory = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public onScrollEndHistory(target: HTMLElement): void {
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      if (this.historyItems.length < this.countItemsHistory && !this.loadingHistory && !this.paginationLoadingHistory) {
        this.paginationLoadingHistory = true;
        this.queryParamsHistory.offset += this.queryParamsHistory.limit;
        this.loadHistory({ concat: true });
      }
    }
  }
}
